import React, { useState } from 'react';

interface ToggleButtonProps {
    initialState?: boolean;
    onChange?: (isActive: boolean) => void;
    label?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ initialState = false, onChange, label = 'Preserved' }) => {
    const [isActive, setIsActive] = useState(initialState);

    const handleToggle = () => {
        const newState = !isActive;
        setIsActive(newState);
        if (onChange) {
            onChange(newState);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginLeft: 'auto',
            }}
        >
            <button
                style={{
                    position: 'relative',
                    width: '28px',
                    height: '17px',
                    borderRadius: '34px',
                    backgroundColor: isActive ? '#0077c2' : '#e3e3e3',
                    padding: 0,
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                }}
                onClick={handleToggle}
                aria-pressed={isActive}
                type='button'
            >
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            height: '9px',
                            width: '9px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            top: '4px',
                            left: '3px',
                            transition: 'transform 0.3s',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            transform: isActive ? 'translateX(13px)' : 'translateX(0)',
                        }}
                    ></div>
                </div>
            </button>
            {label && (
                <span
                    style={{
                        fontSize: '18px',
                    }}
                >
                    {label}
                </span>
            )}
        </div>
    );
};

export default ToggleButton;
